var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransferFeeDetail',{attrs:{"url-c-r-m":_vm.urlCRM,"url-o-m-s":_vm.urlOMS,"url-e-r-p":_vm.urlERP,"student":_vm.student},on:{"close":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }